import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import ObjectUtil from '@leverege/object-util'

import { Receiver } from 'react-file-uploader';
import { Screen, TextInput, LabelGroup } from '~/views'
import { ProjectActions, NotifyActions, BlueprintImporter, BreadcrumbActions } from '~/actions';

import style from './importRawBlueprintsScreen.css'

class ImportRawBlueprintsScreen extends React.Component {

  static contextTypes = { 
    api : PropTypes.object.isRequired
  }

  constructor( props ) {
    super( props );
    this.state = { error : false, blueprint : null, definition : null }
  }

  componentDidMount() {
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ 
      { name : 'Blueprints', link : `/project/${this.props.match.params.projectId}/blueprint` },
      { name : 'Import' } ] ) )
  }

  onDragEnter = ( e ) => {
    // console.log( 'drag enter', e )
  }
  
  onDragLeave = ( e ) => {
    // console.log( 'drag leave', e )
  }
  
  onDragOver = ( e ) => {
    // console.log( 'drag over', e )
  }

  onFileDrop = ( e, files ) => {
    const { api } = this.context
    const { dispatch, match : { params } } = this.props
    if ( files.length != 1 ) {
      dispatch( NotifyActions.warn( 'Too Many Files', 'You can only import one blueprint' ) )
      return
    }
    const file = files[0] && files[0].data
    if ( !( file.type == 'application/json' || file.type == 'text/plain' ) ) {
      dispatch( NotifyActions.warn( 'Wrong File Type', 'You can only import JSON or text' ) )
      return
    }

    const reader = new FileReader()
    reader.onload = async ( e ) => {
      try {
        const blueprints = await api.project( params.projectId ).blueprints().list( { perPage : 1000 } )
        const def = verify( e.target.result, blueprints && blueprints.items )
        this.setState( { blueprint : e.target.result, definition : def, name : def.name } );
      } catch ( ex ) {
        console.log( ex )
        dispatch( NotifyActions.error( 'Read Error', 'This is not a json/blueprint file' ) )
      }
    }
    reader.onloadstart = ( e ) => {
      this.setState( { loading : true, fileName : file.name } )
    }
    reader.onloadend = ( e ) => {
      this.setState( { loading : false } )
    }
    reader.onerror = ( e ) => {
      console.log( e )
      dispatch( NotifyActions.error( 'Read Error', 'An error occured reading the file' ) )
    }
    reader.readAsText( file )

    // close the Receiver after file dropped
  }

  onChangeName = ( v, err ) => {
    if ( err ) {
      console.log( 'err in change name', err )
      return
    }
    const { definition, blueprint } = this.state
    let u = JSON.parse( blueprint )
    const empty = v == null || v.trim().length == 0
    u.name = empty ? definition.name : v
    u = JSON.stringify( u, null, 2 )
    this.setState( { blueprint : u, name : v } )
  }

  onCreate = ( ) => {
    const { definition, name } = this.state
    const { params } = this.props.match
    if ( definition && params.projectId ) {
      const copy = ObjectUtil.copy( definition )
      if ( name != null && name.trim().length != 0 ) {
        copy.name = name.trim()
      }
      this.props.dispatch( ProjectActions.addBlueprint( params.projectId, copy, this.props.history ) )
        .then( 
          ( bp ) => { 
            console.log( 'Should i switch url locations??', bp ); 
            // this.props.history.push( `/project/${bp.projectId}/blueprint/${bp.id}` )
            this.setState( { uploading : false } ) 
          },
          ( err ) => { this.setState( { uploading : false } ) } )
      this.setState( { uploading : true } )

    }
  }

  render() {
    const { error, blueprint, definition, uploading, name } = this.state
    if ( error ) {
      return <div>Error loading blueprint...</div>;
    } 
    let summary 
    if ( definition ) {
      const errors = definition.errors.length
      summary = (
        <span className={style.summary}>
          Attributes : 
          {' '}
          {definition.attributes.length}
          {errors ? ', ' : null}
          {errors ? (
            <span className={style.warn}>
              Unknowns :
              {' '}
              {errors}
            </span>
          ) : null }
        </span>
      )

    }
    return (
      <Screen>
        <Screen.Header className={style.header}>

          <Button onClick={() => { this.onCreate( ) }} disabled={definition == null}>
            <i className="fa fa-upload fa-fw" />
            {' '}
            Create
          </Button>
          &nbsp;
          {summary}
          {definition == null ? null : 
            (
              <LabelGroup>
                <label>Import Name</label>
                <TextInput hint="Name..."
                  value={name} 
                  changeOnReturn={false} 
                  onChange={this.onChangeName} />
              </LabelGroup>
            )}

        </Screen.Header>

        <Screen.Content>
          <Receiver
            isOpen
            onDragEnter={this.onDragEnter}
            onDragOver={this.onDragOver}
            onDragLeave={this.onDragLeave}
            onFileDrop={this.onFileDrop}>
            <div>
              {blueprint == null ? 
                <div className={style.hint}>Drag a blueprint file here</div> :
                <pre style={{ background : 'white', position : 'absolute', overflow : 'auto', height : '100%', width : '100%', margin : 0 }}>{blueprint}</pre>}
            </div>
          </Receiver>
          
        </Screen.Content>
        {uploading ? 
          (
            <div className={style.uploading}>
              <i className="fa fa-spin fa-refresh fa-lg" />
              <div>Creating...</div>
            </div>
          ) : null} 
      </Screen>
    )
  }

} 

function verify( str, blueprints ) {
  const json = JSON.parse( str )
  return BlueprintImporter.jsonToBlueprint( json, blueprints )
}

const ignore = {
  id : true,
  created : true,
  lastModified : true,
  blueprintId : true,
  projectId : true
}

function replacer( key, value ) {
  if ( ignore[key] ) {
    return undefined
  }
  return value
}

export default connect( state => ( { } ) )( ImportRawBlueprintsScreen )
